
import { defineComponent, ref, onMounted, onBeforeMount } from 'vue'
import LoginBackground from '../components/Login/LoginBackground.vue'
import LoginBox from '../components/Login/LoginBox.vue'
import { getUrlQuery } from '@/utils/utils'
import loginService from '@/services/loginService'

export default defineComponent({
	name: 'Login',
	components: {
		LoginBackground,
		LoginBox
	},
	setup() {
		const screenWidth = window.screen.width
		let clientWidth = document.body.clientWidth
		const zoomRatio = ref(clientWidth / screenWidth)
		const containerShow = ref(false)
		let service = ''
        if (getUrlQuery('redirectURL')) {
            service = getUrlQuery('redirectURL') as string
        }
		const verifyLoginStatus = () => {
            loginService.initializeVerifyLoginStatus(encodeURIComponent(service)).then((res: any) => {
                if (res.code === '200' && res.data?.redirectUrl) {
					console.log('url', encodeURIComponent(service), res.data?.redirectUrl, )
                    window.location.replace(res.data?.redirectUrl)
					// containerShow.value = true
                }else {
					console.log('2121212')
                    containerShow.value = true
                }
            }).catch((err) => {
                console.log(err)
                containerShow.value = true
            })
            
        }
        onBeforeMount(async () => {
            await verifyLoginStatus()
        })
		onMounted(() => {
			window.addEventListener('resize', () => {
				clientWidth = document.body.clientWidth
				zoomRatio.value = clientWidth / screenWidth
			})
		})
		const baseRatio = ref(screenWidth / 1920) // 以1920为基准
		return {
			baseRatio,
			zoomRatio,
			containerShow
		}
	}
})
